var map = {
	"./cards.vue": 46,
	"./copy.vue": 50,
	"./drag-class.vue": 52,
	"./drag-delay.vue": 54,
	"./drag-handle.vue": 56,
	"./events.vue": 58,
	"./form.vue": 62,
	"./groups.vue": 64,
	"./lock-axis.vue": 68,
	"./nested.vue": 70,
	"./simple-horizontal.vue": 74,
	"./simple-scroller.vue": 76,
	"./simple.vue": 78,
	"./table.vue": 80,
	"./transition-duration.vue": 84
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;


//////////////////
// WEBPACK FOOTER
// ./src/pages ^\.\/.*\.vue$
// module id = 45
// module chunks = 0